import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { BRAND_SETTINGS_FETCH_COLORS, BRAND_SETTINGS_FETCH_STARTED, BRAND_SETTINGS_FETCH_SUCCEEDED, BRAND_SETTINGS_FETCH_FAILED, BRAND_SETTINGS_BUSINESS_UNIT_FETCH, BRAND_SETTINGS_BRAND_KIT_FETCH, BRAND_SETTINGS_LOGO_FETCH, BRAND_SETTINGS_LOGO_CREATE } from 'ContentData/actions/ActionTypes';
import * as brandingClient from 'ContentData/api/Branding';
const fetchBrandColorsAction = createGenericFetchAction(BRAND_SETTINGS_FETCH_COLORS, brandingClient.fetchBrandColors);
export const fetchBrandColors = businessUnitId => fetchBrandColorsAction(businessUnitId);
export const fetchBranding = businessUnitId => {
  return dispatch => {
    dispatch({
      type: BRAND_SETTINGS_FETCH_STARTED
    });
    return brandingClient.fetchBranding().then(brandData => {
      dispatch({
        type: BRAND_SETTINGS_FETCH_SUCCEEDED,
        brandData,
        businessUnitId
      });
    }).catch(err => {
      dispatch({
        type: BRAND_SETTINGS_FETCH_FAILED,
        err
      });
    });
  };
};
export const fetchBusinessUnit = (type, pageId) => {
  return dispatch => {
    dispatch({
      type: BRAND_SETTINGS_BUSINESS_UNIT_FETCH
    });
    const fetchBusinessUnitPromise = brandingClient.fetchBusinessUnit(type, pageId);
    return fetchBusinessUnitPromise.then(response => {
      const {
        businessUnitId
      } = response;
      if (!isNullOrUndefined(businessUnitId)) {
        dispatch({
          type: BRAND_SETTINGS_BUSINESS_UNIT_FETCH,
          businessUnitId
        });
      }
      return fetchBusinessUnitPromise;
    }).catch(error => {
      dispatch({
        type: BRAND_SETTINGS_BUSINESS_UNIT_FETCH,
        error
      });
      return fetchBusinessUnitPromise;
    });
  };
};
export const fetchBrandKit = businessUnitId => {
  return dispatch => {
    dispatch({
      type: BRAND_SETTINGS_BRAND_KIT_FETCH
    });
    return brandingClient.fetchBrandKit(businessUnitId).then(brandKitData => {
      const {
        id
      } = brandKitData;
      dispatch({
        type: BRAND_SETTINGS_BRAND_KIT_FETCH,
        brandKitId: id
      });
    }).catch(error => {
      dispatch({
        type: BRAND_SETTINGS_BRAND_KIT_FETCH,
        error
      });
    });
  };
};
export const createBrandedLogo = (logoData, query) => {
  return dispatch => {
    dispatch({
      type: BRAND_SETTINGS_LOGO_CREATE
    });
    return brandingClient.createLogo(logoData, query).then(brandedLogo => {
      dispatch({
        type: BRAND_SETTINGS_LOGO_CREATE,
        brandedLogo
      });
      return brandedLogo;
    }).catch(error => {
      dispatch({
        type: BRAND_SETTINGS_LOGO_CREATE,
        error
      });
      throw error;
    });
  };
};
export const fetchBrandedLogo = (domain, buid) => {
  return dispatch => {
    dispatch({
      type: BRAND_SETTINGS_LOGO_FETCH
    });
    return brandingClient.fetchLogo(domain, buid).then(brandedLogo => {
      const {
        logoUrl
      } = brandedLogo;
      if (!isNullOrUndefined(logoUrl)) {
        dispatch({
          type: BRAND_SETTINGS_LOGO_FETCH,
          brandedLogo
        });
      }
    }).catch(error => {
      dispatch({
        type: BRAND_SETTINGS_LOGO_FETCH,
        error
      });
    });
  };
};